import { LayoutOutletFlow } from './_layout_outlet_flow.component';
import { LayoutOutletMain } from './_layout_outlet_main.component';
import { LayoutOutletNavigation } from './_layout_outlet_navigation.component';
import { LayoutOutletTextPage } from './_layout_outlet_text_page.component';
import { LayoutOutletWithHeader } from './_layout_outlet_with_header.component';

export const LayoutOutlet = {
	WithHeader: LayoutOutletWithHeader,
	Navigation: LayoutOutletNavigation,
	Main: LayoutOutletMain,
	TextPage: LayoutOutletTextPage,
	Flow: LayoutOutletFlow,
} as const;
